export default __webpack_public_path__ + "static/hardink-b37ff7183c334c220e1f9365e5b9e4fd.jpg";